import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import GraphqlHTTPRequest from "./GraphqlHTTPRequest.png";
import RandomDelayMaximum from "./RandomDelayMaximum.png";
import HTTPHeaderManager from "./HTTPHeaderManager.png";
import TestPlan from "./TestPlan.png";
import ThreadGroups from "./ThreadGroups.png";

const JMeter: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <h1>
        <a href='https://jmeter.apache.org/'>JMeter</a>
      </h1>
      <div className='mt-4 text-left'>
        <p className='text-muted'>
          Aquí encontrará contenido sobre pruebas de rendimiento o performance,
          desde la instalación y la configuración de JMeter, herramienta
          utilizada para el ejemplo que se abordará más abajo. La velocidad de
          un sitio es un factor clave en el ranking de los resultado de búsqueda
          de Google, por lo tanto, si el sitio de una compañia tiene altos
          tiempos de espera, Google no lo va a ubicar entre los primeros
          resultados de las búsquedas. Y por si no lo sabías, respecto de la
          segunda página de los resultados de Google,{" "}
          <strong>
            puedes enterrar un muerto allí y nadie lo va a encontrar
          </strong>
          . Hoy en día los negocios se mueven en el mundo online y los temas de
          rendimiento de un sistema realmente marcan la diferencia en le
          mercado. Esto lo saben las empresas, por lo que cada día es más
          importante contratar personal testers especializados en hacer las
          pruebas de performance.
        </p>
        <p className='text-muted'>
          En el ejemplo práctico de esta oportunidad viene de la mano de las
          pruebas de concurrencias realizadas sobre unos de los proyectos que
          Crombie desarrolla llamado ReCreo. Entonces, a continuación verá cómo
          implementar pruebas de perfomance usando la herramienta JMeter, y
          antes de adentrarnos en los aspectos técnicos y prácticos se deja
          recomendación de una referencia biblográficas en español para aprender
          y conocer un poco más de JMeter y las pruebas de performance.
          <a href='https://www.federico-toledo.com/libro-de-testing-introduccion-a-las-pruebas-de-sistemas-de-informacion/'>
            {" "}
            Introduccion a las pruebas de sistemas de informacion{" "}
          </a>
          . La bibliografía contiene un capítulo dedicado a ello.
        </p>
      </div>
      <h3 className='text-muted'>Pasos a seguir</h3>

      <h4 className='text-info'>1. Instalación</h4>
      <div className='mt-4 text-cleft'>
        <p className='text-muted'>
          Las pruebas de performance es una investigación técnica para
          determinar o validar la velocidad, escalabilidad y/o estabilidad de un
          sistema bajo prueba para analizar su desempeño en situaciones de
          carga. Lo primero será dirigirse a la página oficial de{" "}
          <a href='https://jmeter.apache.org/download_jmeter.cgi'>JMeter</a>.
          JMeter es un proyecto Apache y en su sitio oficial puede encontrar
          manuales de buenas prácticas, referencias, últimos cambios sobre la
          herramienta. En los archivos binarios encontrará las últimas versiones
          de la aplicación, y en este caso se usa .zip para el caso de Windows
          10. El siguiente paso será extraer todos los archivos que se debe
          utilizar para la ejecución de la herramienta.Antes de ejecutar la
          herramienta, es necesario tener instalado previamente la máquina
          virtual o JDK de Java y para ello deberá dirigirse a la página de
          Oracle{" "}
          <a href='https://www.oracle.com/java/technologies/javase-downloads.html'>
            {" "}
            Oracle{" "}
          </a>
          donde está el proyecto Java. <br />
          Lo siguiente será seleccionar la ubicación donde desea que queden los
          binarios del JDK. En mi caso voy a utilizar: c:\\java.
          <br />
          Se ha creado una carpeta llamada jdk-16.0.1. Debe recordar esta ruta
          para configurarla en las variables de entorno.
          <br />
          Para la creación de las variables de entorno se debe crear la variable
          de entorno JAVA\_HOME y se debe actualizar la variable de entorno
          PATH. La primera se utilizará para que java sepa dónde
          <br />
          se encuentra la instalación del JDK y la segunda es para poder
          ejecutar los comandos de java (como javac, java, etc) desde cualquier
          lugar.
          <br />
          <br />
          <p className='text-info'>JAVA_HOME</p>
          En la lupa de la barra de windows debe escribir: Editar las variables
          de entorno del sistema y damos clic en la opción que nos da.
          <br />
          Se abre la ventana de 'Propiedades del sistema' y en la pestaña de
          'Opciones avanzadas' seleccinará 'Variables de entorno'.
          <br />
          Puede crear las variables de entorno para el usuario actual o para el
          sistema. Yo lo hice para el sistema, con el fin de que cualquier
          usuario tenga acceso a la ejecución de java.
          <br />
          En el grupo de 'Variables del sistema' seleccionar el botón de 'Nueva'
          y el nombre a utilizar será JAVA\_HOME.
          <br />
          En el valor debe escribir la ruta donde se descomprimió el jdk, en mi
          caso será: <code className='text-info'>c:\java\jdk-16.0.1</code>.
          Click en aceptar. Ya debe aparecer esta variable en el grupo.
          <br />
          <br />
          <p className='text-info'>PATH</p>
          Si no tiene abierta la ventana de 'Variables de entorno' debe abrirla
          como se indicó previamente.
          <br />
          En el grupo 'Variables del sistema' ubica la variable Path,
          seleccionala y da clic en Editar para poder ver todos los valores de
          Path. <br />
          No los modifiques o elimines!. Agrega un nuevo valor dando clic en el
          botón 'Nuevo' y digitando la ruta de la instalación de java agregando
          la carpeta bin. En mi caso es:{" "}
          <code className='text-info'>c:\java\jdk-16.0.1\bin</code>.<br />
          Hacer clic en aceptar, luego en aceptar y luego nuevamente en aceptar.
          <br />
          Ahora ya puedes abrir una consola dando clic en la lupa de la barra de
          windows, escribes cmd y seleccionas simbolo del sistema. <br />
          Cuando te aparezca, ya puedes confirmar que la instalación ha quedado
          correcta digitando:
          <br />
          <br />
          <code className='text-info'>
            java -version
            <br />
            La salida debe ser algo como esto:
            <br />
            openjdk 16.0.1 2021-04-20
            <br />
            OpenJDK Runtime Environment (build 16.0.1+9-24)
            <br />
            OpenJDK 64-Bit Server VM (build 16.0.1+9-24, mixed mode, sharing)
            <br />
          </code>
          <br />
          <h4 className='text-info'>
            2. Presentación de aplicación bajo prueba
          </h4>
          Para ejecutar JMeter en Windows es necesario ejecutar el archivo
          jmeter.bat ubicado en la carpeta{" "}
          <code className='text-info'>/bin</code>. La configuración de las
          pruebas corresponden a pruebas de concurrencias sobre queries en
          Graphql con y sin autorización. Cada Thread Group cuenta con la
          configuración de una GraphQL HTTP Request por cada una de las queries
          para las pruebas de concurrencia. Cada una de las GraphQL HTTP Request
          cuenta con la configuración del Web Server con protocolo https,
          ‘recreo.gba.gob.ar’ para el server name or IP, HTTP Request de tipo
          POST para las queries que requieren token. Para el Path se pasa el
          valor <code className='text-info'>/graphql/auth</code>. En la sección
          de GraphQL Request se pasa la query de prueba.
          <br />
          Se adjunta captura de pantalla. Para el caso de las que no requieren
          token, el HTTP Request fue de GET con Path{" "}
          <code className='text-info'>/graphql</code>.<br />
          <br />
          <img
            width={1200}
            alt='GraphQL HTTP Request'
            src={GraphqlHTTPRequest}
            className='mw-100 align-self-center'
          />
          <br />
          <p className='text-info'>
            <br />
            TIMER
          </p>
          Además, por cada una de las request se aplica un Timer de tipo random
          ‘Uniform Random Timer’ con un Random Delay Maximum (in millisconds) de
          100.00
          <br />
          <br />
          <img
            width={1200}
            alt='Random Delay Maximum'
            src={RandomDelayMaximum}
            className='mw-100 align-self-center'
          />
          <br />
          <br />
          <p className='text-secondary'>*Explicación:</p>
          Random delay maximum: 100
          <br />
          Constante delay offset: 0<br />
          <br />
          Este detendrá las peticiones afectadas en un número aleatorio de
          milisegundos para un rango 0 a 99, ya que la fórmula está dada por:
          <br />
          <br />
          <code className='text-info'>
            0.X *random delay maximum + constant offset
            <br />
            0.X *100 + 0
          </code>
          <br />
          <br />
          Donde X puede ser cualquier valor entre 0 y 9.
          <br />
          X da la probabilidad de ocurrencia de un valor entre 0 y 9.
          <br />
          <br />
          <p className='text-secondary'>*Ejemplos:</p>
          Ejecución aleatoria 1: 0.1 * 100 + 0 = 10ms
          <br />
          Ejecución aleatoria 2: 0.8 * 100 + 8 = 80ms
          <br />
          <br />
          <p className='text-info'>HTTP Header Manager</p>
          Para cada Thread Group se añadió un elemento de configuración ‘HTTP
          Header Manager’ con los siguientes valores. Se adjunta capturas de
          pantalla.
          <br />
          <img
            width={1200}
            alt='Random Delay Maximum'
            src={HTTPHeaderManager}
            className='mw-100 align-self-center'
          />
          <br />
          <br />
          En la imagen anterior se observa la configuración para las queries con
          token. En el caso de las queries sin token solo se pasó{" "}
          <code className='text-info'>content-type</code> con valor{" "}
          <code className='text-info'> application/json</code>.<br />
          <br />
          <p className='text-info'>Configuración del Test Plan</p>
          Respecto de la configuración del Test Plan se varió entre: ejecutar
          grupos de subprocesos de forma consecutiva (es decir, uno a la vez).
          El plan de prueba tiene 2 grupos de subprocesos y cada subproceso se
          ejecutó uno tras otro y en paralelo variando combinaciones por cada
          una de las queries en cada subproceso. <br />
          Ejecutar grupos de subprocesos de desmontaje después del cierre de los
          subprocesos principales. (Por defecto configurada en la herramienta.)
          Los subprocesos de TearDown se ejecutan después de que la prueba ha
          terminado de ejecutar su grupo de subprocesos normal. Si esta casilla
          de verificación está marcada, este hilo se ejecutará después de la
          ejecución de la prueba. La función tearDown se utiliza generalmente
          para informes o operaciones de limpieza. Por ejemplo , si desea que
          sus registros se limpien automáticamente después de la ejecución de un
          plan de prueba o desea que sus informes tengan un formato particular,
          puede usar esta propiedad del plan de prueba.
          <br />
          <br />
          <img
            width={1200}
            alt='Test Plan'
            src={TestPlan}
            className='mw-100 align-self-center'
          />
          <br />
          <br />
          <p className='text-info'>Thread Group</p>
          Aquí solo se varió el número de hilos y el ramp-up para los diferentes
          escenarios de pruebas. Se adjunta captura de pantalla que muestra 50
          hilos con ramp-up de 1. <br />
          <img
            width={1200}
            alt='Thread Groups'
            src={ThreadGroups}
            className='mw-100 align-self-center'
          />
          Si necesita pruebas de carga a gran escala, considere ¡No usar el modo
          GUI para pruebas de carga!, solo para la creación de pruebas y la
          depuración de pruebas. Para las pruebas de carga, use el modo CLI como
          lo recomienda la herramienta.
          <br />
          <br />
          <p className='text-info'>CLI Mode</p>
          La ejecución de estos script se realizó a través de CLI Mode con
          versión de java identificada previamente.
          <br />
          <br />
          <p className='text-secondary'>
            *Ejemplo de comando de ejecución, desde el binario de JMeter:
          </p>
          <code className='text-info'>
            C:\Users\USUARIO\Desktop\JMeter\apache-jmeter-5.4.1\bin{">"} jmeter
            -n -t fileconscript.jmx
            <br />
          </code>
          <br />
          <p className='text-secondary'>
            *Ejemplo de comando de ejecución, desde el binario de JMeter:
          </p>
          <code className='text-info'>
            Creating summariser ..
            <br />
            Created the tree successfully using TestPlanloadtestboth-copia.jmx
            <br />
            Starting standalone test @ Wed Jul 14 11:04:05 ART 2021
            (1626271445525)
            <br />
            Waiting for possible Shutdown/StopTestNow/HeapDump/ThreadDump
            message on port 4445
            <br />
            …<br />
            summary + 93 in 00:00:02 = 53.2/s Avg: 88 Min: 51 Max: 333 Err: 0
            (0.00%) Active: 0 Started: 10000 Finished: 10000
            <br />
            summary = 150000 in 00:30:01 = 83.3/s Avg: 125 Min: 45 Max: 8514
            Err: 0 (0.00%)
            <br />
            Tidying up ... @ Thu Jul 01 10:34:31 ART 2021 (1625146471751)
            <br />
            ... end of run
            <br />
          </code>
          <br />
          <br />
          <p className='text-secondary'>*Referencias de datos obtenidos:</p>
          En <code className='text-info'>00:30:01</code> se enviaron{" "}
          <code className='text-info'>10000</code> peticiones al servidor (con
          /auth) con un rendimiento promedio de{" "}
          <code className='text-info'>83.3/s</code>
          <br />
          <code className='text-info'>Avg:</code> El tiempo de respuesta
          promedio en ese momento fue de{" "}
          <code className='text-info'>125 ms</code>.<br />
          <code className='text-info'>Min</code>: El tiempo mínimo de respuesta
          de las solicitudes de envío para ese período fue de{" "}
          <code className='text-info'>45 ms</code>.<br />
          <code className='text-info'>Max</code>: El tiempo máximo de respuesta
          de las solicitudes de envío para ese período fue de{" "}
          <code className='text-info'>8514 ms</code>.<br />
          <code className='text-info'>Err</code>: Se obtuvieron 0 errores en las
          solicitudes durante ese período de tiempo, y en consecuencia, el % de
          error del total de solicitudes es <code className='text-info'>0</code>
          .<br />
          Total de muestras <code className='text-info'>150000</code> durante
          30min (rump-aup 1800 segundos) ={" "}
          <code className='text-info'>5.5 req/seg</code> ={" "}
          <code className='text-info'>83.3 req/seg</code> enviadas al servidor
          para 15 queries en simultáneo.
          <br />
          <br />
        </p>
      </div>
    </Container>
  );
};

export default new Content({
  Component: JMeter,
  title: "JMeter",
  route: "jmeter",
  tags: [
    "git",
    "gitflow",
    "version",
    "version control",
    "bitbucket",
    "repository"
  ]
});
